module.exports = __webpack_public_path__ + "media/images/client-21-752d8011d99b6a41a5c34db0cbca1172.png";